import { csrfHeaders } from '@/components/csrf';

export const PAGE_VIEWS_PATH = '/api/v4/single_root/page_views';
// The Recently viewed widget refetches on this; document loads never dispatch it.
export const PAGE_VIEWED_EVENT = 'single-root:page-viewed';

export type PageViewRecorder = (href: string, title: string) => void;

/**
 * Records "Recently viewed" for a client navigation, as `mark_recently_viewed` does for a
 * document load. The server decides whether the URL records a view and authorizes its record.
 * Best effort: a failure never surfaces to the user.
 */
export const createPageViewRecorder =
  (fetchImpl: typeof fetch = async (...args) => fetch(...args)): PageViewRecorder =>
  (href, title) => {
    fetchImpl(PAGE_VIEWS_PATH, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...csrfHeaders()
      },
      body: JSON.stringify({ href, title })
    })
      .then((response) => {
        if (response.ok) window.dispatchEvent(new Event(PAGE_VIEWED_EVENT));
      })
      .catch(() => undefined);
  };
